import { createSuscriber } from '../../app/services/Suscriber/createSuscriber'
import { getSubscriberStatusCorpEntities } from '../../app/services/Suscriber/getSubscriberStatusCorpEntities'
import { getSuscriberRefId } from '../../app/services/Suscriber/getSuscriberFromRefId'
import { helpGetSuscriberOrganization } from '../../app/services/Suscriber/helpGetSuscriberOfOrganization'
import { helpGetUserOfSuscriber } from '../../app/services/Suscriber/helpGetUsersOfSuscriber'
import { logEvent } from '../../utils/LogEvents'
import { setErrorTextSnackBar, setRequestTextSnackBar } from './app'

// get suscriber with REF ID
export const getSuscriberRefID = (params) => {
  return async (dispatch) => {
    try {
      const response = await getSuscriberRefId(params)
      return response.data
    } catch (error) {
      if (
        !error.response?.data?.message
          ?.toLowerCase()
          .includes('datos no encontrados')
      ) {
        if (error.response?.status === 404) {
          dispatch(setRequestTextSnackBar())
          dispatch(
            setErrorTextSnackBar(
              'Ocurrió un error en un servicio de: OrganizationApi'
            )
          )
        }
        if (error.response?.data) {
          dispatch(setRequestTextSnackBar())
          dispatch(
            setErrorTextSnackBar(
              'Ocurrió un error en un servicio de: ' + error.response?.data
            )
          )
        }
      }
      return null
    }
  }
}

export const createSuscriberRequest = (suscriber, myuuid = null) => {
  return async (dispatch) => {
    try {
      const response = await createSuscriber(suscriber)
      logEvent(
        'CGI - createSubscriberCorpEntities',
        {
          body: suscriber,
          response: response
        },
        myuuid
      )
      return response.data
    } catch (error) {
      if (error.response?.data?.message?.includes('Suscriptor ya existente')) {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Suscriptor ya existente'))
      } else {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Ocurrió un error.'))
      }
      return 'error'
    }
  }
}

// get suscribers with org ID
export const getSuscribersWithOrgID = (id) => {
  return async (dispatch) => {
    try {
      const response = await helpGetSuscriberOrganization(id)
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: SuscribersAPI'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return []
    }
  }
}

// get user of subscriber with ID
export const getUserOfSuscribersWithID = (id) => {
  return async (dispatch) => {
    try {
      const response = await helpGetUserOfSuscriber(id)
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: SuscribersAPI'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return []
    }
  }
}

// get status of subscriber
export const getSubscriberStatus = () => {
  return async (dispatch) => {
    try {
      const response = await getSubscriberStatusCorpEntities()
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: SuscribersAPI'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return []
    }
  }
}

// get users of subscriber
export const getUsersOfSuscriber = (clicod) => {
  return async (dispatch) => {
    try {
      const response = await helpGetUserOfSuscriber(clicod)
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: SuscriberApi'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return null
    }
  }
}
